import type { History } from "history";
import { useState, useContext, useEffect, useRef, useCallback } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export const usePrompt = (when = false) => {
  const [flag, setFlag] = useState(false);
  const confirm = useRef<any>(null); // eslint-disable-line
  const context = useRef<any>(null); // eslint-disable-line
  const { navigator } = useContext(NavigationContext);
  const blockNavigator = navigator as History;

  const next = useCallback(() => {
    if (confirm.current) {
      confirm.current();
      context.current?.retry?.();
    }
  }, []);

  useEffect(() => {
    if (!when) return;
    const unblock = blockNavigator.block((tx) => {
      setFlag(true);
      context.current = tx;
    });
    confirm.current = unblock;
    return unblock;
  }, [blockNavigator, when]);

  return { flag, setFlag, next };
};